import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

// Components
import Header from '../components/Header';
import {Pages} from '../common/vars';
import TitleText from "../elements/TitleText";
import TextBlock from "../elements/TextBlock";
import FooterLogo from "../elements/FooterLogo";
import ResumeDownload from "../elements/ResumeDownload";

class ResumePage extends Component {

  page = Pages[2];

  content = this.page.content;

  render() {
    return (
      <article className="page about">
        <Header image={this.page.img} svg={this.page.svg} title={this.page.name} subtitle={this.page.subtitle}/>
        <div className="page__content">
          <TextBlock title={this.content[0].title} content={this.content[0].content}
                     className="text-block--first text-block--left text-block--small-left"/>
          <TitleText title={this.content[1].title} content={this.content[1].content} className="title-text--reverse"/>
          <TitleText title={this.content[2].title} content={this.content[2].content}/>
          <TitleText title={this.content[3].title} content={this.content[3].content} className="title-text--reverse"/>
          <ResumeDownload/>
        </div>
        <FooterLogo/>
      </article>
    );
  }
}

const mapStateToProps = state => {
  return {
    resume: state.resume,
  }
};

export default withRouter(connect(mapStateToProps)(ResumePage));


// WEBPACK FOOTER //
// ./src/js/pages/ResumePage.js